<template>
  <div class="plandeteilpage">
    <div class="paylist">
      <span class="listline"></span>
      <p class="paylisttit">
        <span class="title">就诊信息</span>
      </p>
      <div class="payliscon">
        <p>
          <span>就诊人：</span>
          <span>{{visitInfo.PatName}}</span>
        </p>
        <p>
          <span>就诊号：</span>
          <span>{{visitInfo.Code}}</span>
        </p>
        <p>
          <span>就诊科室：</span>
          <span>{{visitInfo.DptName}}</span>
        </p>
        <p>
          <span>就诊医生：</span>
          <span>{{visitInfo.DctName}}</span>
        </p>
        <p>
          <span>就诊时间：</span>
          <span>{{visitInfo.VisitTime}}</span>
        </p>
      </div>
    </div>
    <div class="plannav">
      <span class="navspan">治疗计划</span>
      <!--<span :class="{'active':!hasshouw}" @click="toggleTab(false)" class="navspan">执行记录</span>-->
    </div>
    <div v-show="hasshouw" style="height:auto;overflow: auto;">
      <div class="treatplan" v-for="item in treatMedicalOrder">
        <div>
          <p class="treatname">
            <img src="../../assets/images/treat.png" alt>
            <span>{{item.MoName}}</span>
            <span class="nameDetail" @click="nameDeteil(item.MoID)">详情</span>
          </p>
          <div class="pt10">
            <div class="number">
              <div>
                <span>总次数：</span>
                <span class="corbule">{{item.TotalCount}}</span>
              </div>
              <div>
                <span>已执行次数：</span>
                <span class="corbule">{{item.TreatedCount }}</span>
              </div>
              <div>
                <span>剩余次数：</span>
                <span class="corbule">{{item.SurplusCount }}</span>
              </div>
            </div>
            <div class="number">
                <div>
                  <span>退费次数</span>
                  <span class="corbule">{{(item.TotalCount-item.TreatedCount- item.SurplusCount)}}</span>
                </div>
            </div>
            <div class="number">
              <div>
                <span>频次：</span>
                <span>{{item.FrequencyName}}</span>
              </div>
              <div></div>
            </div>
            <div class="number">
              <span>下达时间：</span>
              <span>{{item.StartDate}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="noDate" v-show="!hasshouw">
      <div v-show="true" class="nolist">
        <!-- 无数据显示 -->
        <img src="../../assets/images/searchbg.png" alt class="searchpic">
        <p class="center">暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import { GetTreatMedicalOrder } from "@/services/getData.js";
import weui from "weui.js";
import _ from "lodash";
export default {
  name: "treatment-plandeteil",
  created: function() {
    this.getTreatMedicalOrder();
  },
  data() {
    return {
      hasshouw: true,
      visitID: this.$route.query.visitID,
      visitInfo: [],
      treatMedicalOrder: {}
    };
  },
  methods: {
    toggleTab(state) {
      this.hasshouw = !this.hasshouw;
      if (state == false && getTreatedRecord.length == 0) {
      }
    },
    getTreatMedicalOrder() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetTreatMedicalOrder(this.visitID).then(response => {
        loading.hide();
        if (response.data) {
          this.visitInfo = response.data.Extend;
          this.treatMedicalOrder=response.data.Extend.Detail;
          // this.treatMedicalOrder = _.filter(
          //   response.data.Extend.Detail,
          //   function(item) {
          //     return item.State == 0 || item.State == 3;
          //   }
          // );
          if (this.treatMedicalOrder.length > 0) {
            this.hasshouw = true;
          } else {
            this.hasshouw = false;
          }
        }
      });
    },
    nameDeteil(guid) {
      this.$router.push({
        path: "/treatment/namedeteil",
        query: { moID: guid, visitID: this.visitID }
      });
    }
  }
};
</script>
<style>
.plandeteilpage {
  width: 100%;
  height:auto;
  display: flex;
  overflow: auto;
  flex-direction: column;
}
.plandeteilpage .nolist {
  margin-top: 1.45rem;
}
.plandeteilpage .paylist {
  /* padding: 0 0.2rem; */
  box-sizing: border-box;
  width: 100%;
  height: auto;
  background-color: white;
  position: relative;
  margin-bottom: 0.2rem;
}

.plandeteilpage .paylisttit {
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #1592e4;
  border-bottom: 0.01rem solid rgba(61, 151, 209, 1);
  height: 0.79rem;
  line-height: 0.8rem;
  padding-left: 0.2rem;
  box-sizing: border-box;
  width: 100%;
}

.plandeteilpage .payliscon {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.2rem;
  height: auto;
}

.plandeteilpage .paylist > .payliscon > p {
  width: 100%;
  border-bottom: 0.01rem dotted #dddddd;
  height: 0.79rem;
  line-height: 0.8rem;
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}

.plandeteilpage .paylist > .payliscon > p > span:first {
  color: #333333;
  text-align: left;
}

.plandeteilpage .paylist > .payliscon > p > span:last-child {
  color: #999999;
  text-align: right;
  float: right;
}

.plandeteilpage .paylist > .payliscon > p:last-child {
  border-bottom: none;
}

.plandeteilpage .listline {
  display: block;
  position: absolute;
  width: 0.08rem;
  height: 0.8rem;
  background: rgba(21, 146, 228, 1);
  top: 0;
  left: 0;
}

.plandeteilpage .plannav {
  /* height: 0.8rem; */
  background: rgba(255, 255, 255, 1);
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  display: flex;
  flex-direction: row;
  line-height: 0.8rem;
  margin-bottom: 0.2rem;
  flex: 0 0 0.8rem;
}

.plandeteilpage .plannav > .navspan {
  flex: 1;
  text-align: center;
  display: block;
}

.plandeteilpage .plannav > span:first-child {
  border-right: 0.01rem solid #dddddd;
}

.plandeteilpage .plannav > .active {
  color: #1592e4;
  border-bottom: 0.04rem solid #1592e4;
}

.plandeteilpage .treatplan {
  box-sizing: border-box;
  padding: 0 0.2rem;
  background: white;
  margin-bottom: 0.2rem;
}

.plandeteilpage .treatplan > div {
  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.plandeteilpage .treatplan img {
  width: 0.28rem;
  height: 0.3rem;
  display: inline-block;
  vertical-align: sub;
  margin-right: 0.1rem;
}

.plandeteilpage .treatplan .treatname {
  height: 0.6rem;
  line-height: 0.6rem;
  border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
}

.plandeteilpage .treatplan .nameDetail {
  float: right;
  color: #1592e4;
}

.plandeteilpage .treatplan .number {
  display: flex;
  flex-direction: row;
  line-height: 0.42rem;
}

.plandeteilpage .treatplan .number > div {
  flex: 1;
}

.plandeteilpage .treatplan .number .corbule {
  color: #1592e4;
}

.plandeteilpage .treatplan .nameDetail {
  float: right;
  color: #1592e4;
}
</style>




// WEBPACK FOOTER //
// src/components/treatment/treatment-plandeteil.vue